import { useState } from 'react';
import { snakeCase } from 'lodash-es';

import { hasErrorsMap } from '~/core/shared/api/logic/hasErrorsMap';

type BackendErrorsHook = {
  backendErrors: Record<string, string>;
  setBackendErrors: (errors: Record<string, string>) => void;
  clearBackendErrors: () => void;
  setBackendErrorsFromResponse: (data: unknown) => void;
  getError: (key: string) => string | undefined;
};

type ReactHookFormErrors = Record<string, any>;

export function useBackendErrors(
  formErrors: ReactHookFormErrors,
): BackendErrorsHook {
  const [backendErrors, setBackendErrors] = useState<Record<string, string>>(
    {},
  );

  const getError = (field: string): string | undefined =>
    formErrors?.[field]?.message ?? backendErrors[field];

  return {
    backendErrors,
    clearBackendErrors: () => {
      setBackendErrors({});
    },
    getError,
    setBackendErrors: (errors) => {
      setBackendErrors(errors);
    },
    setBackendErrorsFromResponse: (data: unknown) => {
      if (!hasErrorsMap(data)) return;
      setBackendErrors(
        Object.fromEntries(
          Object.entries(data.errors).map(([key, messages]) => [
            snakeCase(key),
            Array.isArray(messages) ? messages[0] : messages,
          ]),
        ),
      );
    },
  };
}
